/**
 * Simple `requestAnimtaionFram` polyfill
 * @type {Function}
 */
const requestAnimationFrame =
  (typeof window !== 'undefined' &&
    (window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame)) ||
  ((callback) => setTimeout(callback, 10))

export default requestAnimationFrame
